
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class SingleData extends Vue {
  @Prop() title!: string;
  @Prop() id!: string;
  @Prop() fields!: any;
}
